import * as React from 'react';
import classnames from 'classnames';
import { FilesList } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const PrescriptionUploadSummary = ({ uploadReferences , className  })=>{
    const { getLabel  } = useIntl();
    const filteredUploadedFileNames = Object.values(uploadReferences).reduce((m, ref)=>!ref ? m : [
            ...m,
            ref.fileName
        ]
    , []);
    return (filteredUploadedFileNames === null || filteredUploadedFileNames === void 0 ? void 0 : filteredUploadedFileNames.length) ? /*#__PURE__*/ React.createElement("div", {
        className: classnames('prescription-upload-summary', className),
        "data-t": "prescription-upload-summary"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "caption-head"
    }, getLabel('products.glasses.configurator.footer.upload.title')), /*#__PURE__*/ React.createElement(FilesList, {
        items: filteredUploadedFileNames
    })) : null;
};

export { PrescriptionUploadSummary };
//# sourceMappingURL=PrescriptionUploadSummary.js.map
